<div class="quote-step-juniors">
  <lx-premium-activities-with-options [premiumActivities]="premiumActivities"></lx-premium-activities-with-options>
  <lx-premium-accommodation [premiumAccommodation]="premiumAccommodation"></lx-premium-accommodation>
  <lx-transfers [groupedTransfers]="groupedTransfers"></lx-transfers>
  <lx-unaccompanied-minor [unaccompaniedMinorServices]="unaccompaniedMinorServices"></lx-unaccompanied-minor>
  <lx-private-lesson [privateLesson]="privateLesson"></lx-private-lesson>
  <lx-insurance [insurance]="insurance"></lx-insurance>
</div>
